<mat-form-field appearance>
  <mat-label>
    {{ label }}
  </mat-label>
  <mat-select [formControl]="displayControl" [required]="required">
    @for (optionKey of displayOptionsKeys; track $index; let i = $index) { @if
    (displayFn(displayOptions[i])) {
    <mat-option [value]="i">
      {{ displayFn(displayOptions[i]) }}
    </mat-option>
    } }
  </mat-select>
  @for (errorName of control.errors | keys; track errorName) {
  <mat-error>
    {{ errorDisplayFunction(errorName) | translate }}
  </mat-error>
  }
</mat-form-field>
